import { render, staticRenderFns } from "./AppointmentHistoryEntry.vue?vue&type=template&id=5e2fb6d3"
import script from "./AppointmentHistoryEntry.vue?vue&type=script&lang=js"
export * from "./AppointmentHistoryEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports